/**
 * Spacing scale — 4px base unit.
 * Numeric prop values (e.g. mb={2}) resolve to the corresponding entry.
 * Positional / sizing props (top, left, w, h) are unaffected — they use the `sizes` scale.
 */
export default {
  0: 0,
  0.5: '2px',
  0.75: '3px',
  1: '4px',
  1.5: '6px',
  2: '8px',
  2.5: '10px',
  3: '12px',
  3.5: '14px',
  4: '16px',
  5: '20px',
  6: '24px',
  7: '28px',
  8: '32px',
  9: '36px',
  10: '40px',
  11: '44px',
  12: '48px',
  14: '56px',
  16: '64px',
  20: '80px',
  24: '96px',
}
